// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Restaumatic_PromotionsEngine_MaximalCliques from "../Restaumatic.PromotionsEngine.MaximalCliques/index.js";
import * as Restaumatic_PromotionsEngine_ProductFilter from "../Restaumatic.PromotionsEngine.ProductFilter/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Standard = /* #__PURE__ */ (function () {
    function Standard() {

    };
    Standard.value = new Standard();
    return Standard;
})();
var InformationOnly = /* #__PURE__ */ (function () {
    function InformationOnly() {

    };
    InformationOnly.value = new InformationOnly();
    return InformationOnly;
})();
var RequiresCoupon = /* #__PURE__ */ (function () {
    function RequiresCoupon() {

    };
    RequiresCoupon.value = new RequiresCoupon();
    return RequiresCoupon;
})();
var CartTarget = /* #__PURE__ */ (function () {
    function CartTarget() {

    };
    CartTarget.value = new CartTarget();
    return CartTarget;
})();
var ProductTarget = /* #__PURE__ */ (function () {
    function ProductTarget() {

    };
    ProductTarget.value = new ProductTarget();
    return ProductTarget;
})();
var PromotionIdFilter = /* #__PURE__ */ (function () {
    function PromotionIdFilter(value0) {
        this.value0 = value0;
    };
    PromotionIdFilter.create = function (value0) {
        return new PromotionIdFilter(value0);
    };
    return PromotionIdFilter;
})();
var ProductPromotionRequirements = function (x) {
    return x;
};
var FreeProduct = function (x) {
    return x;
};
var Freeby = /* #__PURE__ */ (function () {
    function Freeby(value0) {
        this.value0 = value0;
    };
    Freeby.create = function (value0) {
        return new Freeby(value0);
    };
    return Freeby;
})();
var PercentageDiscount = /* #__PURE__ */ (function () {
    function PercentageDiscount(value0) {
        this.value0 = value0;
    };
    PercentageDiscount.create = function (value0) {
        return new PercentageDiscount(value0);
    };
    return PercentageDiscount;
})();
var PriceDiscount = /* #__PURE__ */ (function () {
    function PriceDiscount(value0) {
        this.value0 = value0;
    };
    PriceDiscount.create = function (value0) {
        return new PriceDiscount(value0);
    };
    return PriceDiscount;
})();
var CouponValue = /* #__PURE__ */ (function () {
    function CouponValue() {

    };
    CouponValue.value = new CouponValue();
    return CouponValue;
})();
var TextInformation = /* #__PURE__ */ (function () {
    function TextInformation() {

    };
    TextInformation.value = new TextInformation();
    return TextInformation;
})();
var CartValue = /* #__PURE__ */ (function () {
    function CartValue(value0) {
        this.value0 = value0;
    };
    CartValue.create = function (value0) {
        return new CartValue(value0);
    };
    return CartValue;
})();
var FirstOrder = /* #__PURE__ */ (function () {
    function FirstOrder() {

    };
    FirstOrder.value = new FirstOrder();
    return FirstOrder;
})();
var Loyalty = /* #__PURE__ */ (function () {
    function Loyalty() {

    };
    Loyalty.value = new Loyalty();
    return Loyalty;
})();
var HasCoupon = /* #__PURE__ */ (function () {
    function HasCoupon() {

    };
    HasCoupon.value = new HasCoupon();
    return HasCoupon;
})();
var Always = /* #__PURE__ */ (function () {
    function Always() {

    };
    Always.value = new Always();
    return Always;
})();
var Never = /* #__PURE__ */ (function () {
    function Never() {

    };
    Never.value = new Never();
    return Never;
})();
var CartPromotion = /* #__PURE__ */ (function () {
    function CartPromotion(value0) {
        this.value0 = value0;
    };
    CartPromotion.create = function (value0) {
        return new CartPromotion(value0);
    };
    return CartPromotion;
})();
var ProductPromotion = /* #__PURE__ */ (function () {
    function ProductPromotion(value0) {
        this.value0 = value0;
    };
    ProductPromotion.create = function (value0) {
        return new ProductPromotion(value0);
    };
    return ProductPromotion;
})();
var Promotion = function (x) {
    return x;
};
var udecodeProductPromotionRequirements = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "numRequiredItems";
    }
})(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productFilter";
    }
})(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_PromotionsEngine_ProductFilter.udecodeProductSingleFilter))(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "repeatable";
    }
})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))));
var udecodeFreeProduct = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productName";
    }
})(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productValue";
    }
})(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "vatRate";
    }
})(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))));
var showProductPromotionRequirements = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "numRequiredItems";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "productFilter";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "repeatable";
    }
})(Data_Show.showRecordFieldsNil)(Data_Show.showBoolean))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_PromotionsEngine_ProductFilter.showProductSingleFilter)))(Data_Show.showInt));
var newtypePromotion = {
    Coercible0: function () {
        return undefined;
    }
};
var promotionCombineTo = /* #__PURE__ */ (function () {
    var $139 = Data_Newtype.unwrap();
    return function ($140) {
        return (function (v) {
            return v.combineTo;
        })($139($140));
    };
})();
var promotionConditions = /* #__PURE__ */ (function () {
    var $141 = Data_Newtype.unwrap();
    return function ($142) {
        return (function (v) {
            return v.conditions;
        })($141($142));
    };
})();
var promotionId = /* #__PURE__ */ (function () {
    var $143 = Data_Newtype.unwrap();
    return function ($144) {
        return (function (v) {
            return v.promotionId;
        })($143($144));
    };
})();
var promotionPrize = /* #__PURE__ */ (function () {
    var $145 = Data_Newtype.unwrap();
    return function ($146) {
        return (function (v) {
            return v.prize;
        })($145($146));
    };
})();
var promotionFreebies = function (promo) {
    var v = promotionPrize(promo);
    if (v instanceof Freeby) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var promotionTarget = function (promotion) {
    var v = (Data_Newtype.unwrap()(promotion)).conditions;
    if (v instanceof CartPromotion) {
        return CartTarget.value;
    };
    if (v instanceof ProductPromotion) {
        return ProductTarget.value;
    };
    throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 385, column 3 - line 387, column 40): " + [ v.constructor.name ]);
};
var promotionType = /* #__PURE__ */ (function () {
    var $147 = Data_Newtype.unwrap();
    return function ($148) {
        return (function (v) {
            return v.promotionType;
        })($147($148));
    };
})();
var newtypeFreeProduct = {
    Coercible0: function () {
        return undefined;
    }
};
var mkPromotionNoneFilter = /* #__PURE__ */ (function () {
    return new PromotionIdFilter([  ]);
})();
var mkPromotionIdFilter = /* #__PURE__ */ (function () {
    return PromotionIdFilter.create;
})();
var mkPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (conds) {
                return function (prz) {
                    return {
                        promotionId: promoId,
                        promotionType: promoType,
                        conditions: conds,
                        prize: prz,
                        combineTo: promoFilter,
                        autoAssignable: true
                    };
                };
            };
        };
    };
};
var mkProductPromotionRequirements = function (prodFilter) {
    return function (repeat) {
        return function (numReqItems) {
            return {
                productFilter: prodFilter,
                repeatable: repeat,
                numRequiredItems: numReqItems
            };
        };
    };
};
var mkProductPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (reqs) {
                return function (prz) {
                    return mkPromotion(promoId)(promoFilter)(promoType)(new ProductPromotion(reqs))(prz);
                };
            };
        };
    };
};
var mkFreeProducts = function (value) {
    return function (vatRate) {
        return Data_Functor.map(Data_Functor.functorArray)(function (name) {
            return {
                productName: name,
                productValue: value,
                vatRate: vatRate
            };
        });
    };
};
var mkCartPromotion = function (promoId) {
    return function (promoFilter) {
        return function (promoType) {
            return function (reqs) {
                return function (prz) {
                    return mkPromotion(promoId)(promoFilter)(promoType)(new CartPromotion(reqs))(prz);
                };
            };
        };
    };
};
var isAutoAssignablePromotion = /* #__PURE__ */ (function () {
    var $149 = Data_Newtype.unwrap();
    return function ($150) {
        return (function (v) {
            return v.autoAssignable;
        })($149($150));
    };
})();
var inPromotionFilter = function (promotion) {
    return function (filter) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqInt)(promotionId(promotion))(filter.value0);
    };
};
var hasFieldProductPromotionRequirements = function (dictHasField) {
    return dictHasField;
};
var numRequiredItems = function (v) {
    return Data_Record.getField(hasFieldProductPromotionRequirements(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "numRequiredItems";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var repeatable = function (v) {
    return Data_Record.getField(hasFieldProductPromotionRequirements(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "repeatable";
        }
    })()))(Type_Proxy["Proxy"].value)(v);
};
var getFirstPromotionFreeby = function (promo) {
    return Control_Bind.join(Data_Maybe.bindMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Array.head)(promotionFreebies(promo)));
};
var genericPromotionType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Standard.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return InformationOnly.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return RequiresCoupon.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 228, column 1 - line 228, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Standard) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof InformationOnly) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RequiresCoupon) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 228, column 1 - line 228, column 64): " + [ x.constructor.name ]);
    }
};
var showPromotionType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    }))))
};
var udecodePromotionType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionType)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Standard";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    })))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionTarget = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return CartTarget.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return ProductTarget.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 367, column 1 - line 367, column 68): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartTarget) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ProductTarget) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 367, column 1 - line 367, column 68): " + [ x.constructor.name ]);
    }
};
var showPromotionTarget = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionTarget)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var udecodePromotionTarget = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPromotionTarget)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))(Unscramble_Enum.defaultEnumOptions)
};
var genericPromotionPrize = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Freeby(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new PercentageDiscount(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new PriceDiscount(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return CouponValue.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return TextInformation.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 97, column 1 - line 97, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Freeby) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof PercentageDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof PriceDiscount) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof CouponValue) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof TextInformation) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 97, column 1 - line 97, column 66): " + [ x.constructor.name ]);
    }
};
var udecodePromotionPrize = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionPrize)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(udecodeFreeProduct))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeNumber1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Data_Money_Rounded.udecodeMoney)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "CouponValue";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })))))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionFilter = {
    to: function (x) {
        return new PromotionIdFilter(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var showPromotionFilter = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionFilter)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Data_Show.showInt)))({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    }))
};
var udecodePromotionFilter = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericPromotionFilter)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeInt1))))(Unscramble_Generic.defaultOptions)
};
var genericPromotionConditions = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CartPromotion(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new ProductPromotion(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 162, column 1 - line 162, column 76): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartPromotion) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ProductPromotion) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 162, column 1 - line 162, column 76): " + [ x.constructor.name ]);
    }
};
var genericPromotion = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericFreeProduct = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showFreeProduct = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFreeProduct)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    }))
};
var showPromotionPrize = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionPrize)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(showFreeProduct)))({
        reflectSymbol: function () {
            return "Freeby";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showNumber))({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Money_Rounded.showMoney))({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "CouponValue";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "TextInformation";
        }
    }))))))
};
var genericCartPromotionRequirement = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CartValue(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return FirstOrder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Loyalty.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return HasCoupon.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return Always.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return Never.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 29, column 1 - line 29, column 86): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CartValue) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof FirstOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Loyalty) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof HasCoupon) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Always) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof Never) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 29, column 1 - line 29, column 86): " + [ x.constructor.name ]);
    }
};
var showCartPromotionRequirement = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCartPromotionRequirement)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "CartValue";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Always";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Never";
        }
    })))))))
};
var showPromotionConditions = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPromotionConditions)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showCartPromotionRequirement))({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showProductPromotionRequirements))({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })))
};
var showPromotion = {
    show: function (promotion) {
        return "Promotion" + ("\x0a{ promotionId:    " + (Data_Show.show(Data_Show.showInt)((Data_Newtype.unwrap()(promotion)).promotionId) + ("\x0a, promotionType:  " + (Data_Show.show(showPromotionType)((Data_Newtype.unwrap()(promotion)).promotionType) + ("\x0a, conditions:     " + (Data_Show.show(showPromotionConditions)((Data_Newtype.unwrap()(promotion)).conditions) + ("\x0a, prize:          " + (Data_Show.show(showPromotionPrize)((Data_Newtype.unwrap()(promotion)).prize) + ("\x0a, combineTo:      " + (Data_Show.show(showPromotionFilter)((Data_Newtype.unwrap()(promotion)).combineTo) + ("\x0a, autoAssignable: " + (Data_Show.show(Data_Show.showBoolean)((Data_Newtype.unwrap()(promotion)).autoAssignable) + "\x0a}"))))))))))));
    }
};
var udecodeCartPromotionRequirement = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCartPromotionRequirement)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Loyalty";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Always";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Never";
        }
    }))))))))(Unscramble_Generic.defaultOptions)
};
var udecodePromotionConditions = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPromotionConditions)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(udecodeCartPromotionRequirement)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(udecodeProductPromotionRequirements)))))(Unscramble_Generic.defaultOptions)
};
var udecodePromotion = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "autoAssignable";
    }
})(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "combineTo";
    }
})(udecodePromotionFilter)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "conditions";
    }
})(udecodePromotionConditions)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "prize";
    }
})(udecodePromotionPrize)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "promotionId";
    }
})(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "promotionType";
    }
})(udecodePromotionType)(Unscramble.decodeRecordNil)))))));
var freeProductValue = /* #__PURE__ */ (function () {
    var $151 = Data_Newtype.unwrap();
    return function ($152) {
        return (function (v) {
            return v.productValue;
        })($151($152));
    };
})();
var freeProductName = /* #__PURE__ */ (function () {
    var $153 = Data_Newtype.unwrap();
    return function ($154) {
        return (function (v) {
            return v.productName;
        })($153($154));
    };
})();
var getFirstPromotionFreebyName = function (promo) {
    return Data_Functor.map(Data_Maybe.functorMaybe)(freeProductName)(getFirstPromotionFreeby(promo));
};
var isInPromotionFreebies = function (freeby) {
    return function (promo) {
        var v = promotionPrize(promo);
        if (v instanceof Freeby) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqString)(freeby)(Data_Functor.map(Data_Functor.functorArray)(freeProductName)(v.value0));
        };
        return false;
    };
};
var findPromotionFreeby = function (freeby) {
    return function (promo) {
        var v = promotionPrize(promo);
        if (v instanceof Freeby) {
            return Data_Foldable.find(Data_Foldable.foldableArray)(function (freeProduct) {
                return freeby === freeProductName(freeProduct);
            })(v.value0);
        };
        return Data_Maybe.Nothing.value;
    };
};
var eqPromotionType = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionType)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var eqPromotionTarget = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionTarget)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))
};
var isCartPromotion = function ($155) {
    return (function (v) {
        return Data_Eq.eq(eqPromotionTarget)(v)(CartTarget.value);
    })(promotionTarget($155));
};
var isProductPromotion = function ($156) {
    return (function (v) {
        return Data_Eq.eq(eqPromotionTarget)(v)(ProductTarget.value);
    })(promotionTarget($156));
};
var eqPromotionFilter = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionFilter)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqInt))))
};
var eqProductPromotionRequirements = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "repeatable";
    }
})(Data_Eq.eqBoolean))()({
    reflectSymbol: function () {
        return "productFilter";
    }
})(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_PromotionsEngine_ProductFilter.eqProductSingleFilter)))()({
    reflectSymbol: function () {
        return "numRequiredItems";
    }
})(Data_Eq.eqInt));
var eqFreeProduct = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericFreeProduct)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate)))()({
        reflectSymbol: function () {
            return "productValue";
        }
    })(Data_Money_Rounded.eqMoney))()({
        reflectSymbol: function () {
            return "productName";
        }
    })(Data_Eq.eqString)))))
};
var eqPromotionPrize = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionPrize)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqArray(eqFreeProduct))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqNumber)))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Money_Rounded.eqMoney)))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))))
};
var isCouponPromotion = function (promo) {
    return Data_Eq.eq(eqPromotionPrize)(promotionPrize(promo))(CouponValue.value);
};
var isTextPromotion = function (promotion) {
    return Data_Eq.eq(eqPromotionPrize)(promotionPrize(promotion))(TextInformation.value);
};
var eqCartPromotionRequirement = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericCartPromotionRequirement)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(Data_Money_Rounded.eqMoney)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))))))
};
var eqPromotionConditions = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionConditions)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(eqCartPromotionRequirement)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(eqProductPromotionRequirements))))
};
var eqPromotion = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotion)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(eqPromotionType))()({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "prize";
        }
    })(eqPromotionPrize))()({
        reflectSymbol: function () {
            return "conditions";
        }
    })(eqPromotionConditions))()({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(eqPromotionFilter))()({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(Data_Eq.eqBoolean)))))
};
var isCartPromotionOf = function (cartPromotionRequirement) {
    return function (promotion) {
        var v = (Data_Newtype.unwrap()(promotion)).conditions;
        if (v instanceof CartPromotion) {
            return Data_Eq.eq(eqCartPromotionRequirement)(v.value0)(cartPromotionRequirement);
        };
        if (v instanceof ProductPromotion) {
            return false;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 399, column 3 - line 401, column 32): " + [ v.constructor.name ]);
    };
};
var isFirstOrderPromotion = /* #__PURE__ */ (function () {
    return isCartPromotionOf(FirstOrder.value);
})();
var isLoyaltyPromotion = /* #__PURE__ */ (function () {
    return isCartPromotionOf(Loyalty.value);
})();
var ordCartPromotionRequirement = {
    compare: function (v) {
        return function (v1) {
            if (v instanceof CartValue && v1 instanceof CartValue) {
                return Data_Ord.compare(Data_Money_Rounded.ordMoney)(v.value0.minCartValue)(v1.value0.minCartValue);
            };
            if (v1 instanceof CartValue) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof CartValue) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord_Generic.genericCompare(genericCartPromotionRequirement)(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
                reflectSymbol: function () {
                    return "minCartValue";
                }
            })(Data_Money_Rounded.ordMoney)))))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdSum(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments)))))))(v)(v1);
        };
    },
    Eq0: function () {
        return eqCartPromotionRequirement;
    }
};
var ordPromotionConditions = {
    compare: function (v) {
        return function (v1) {
            if (v instanceof ProductPromotion && v1 instanceof ProductPromotion) {
                return Data_Ord.compare(Data_Ord.ordArray(Restaumatic_PromotionsEngine_ProductFilter.ordProductSingleFilter))(Data_Record.getField(hasFieldProductPromotionRequirements(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "productFilter";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0))(Data_Record.getField(hasFieldProductPromotionRequirements(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "productFilter";
                    }
                })()))(Type_Proxy["Proxy"].value)(v1.value0));
            };
            if (v instanceof ProductPromotion && v1 instanceof CartPromotion) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof CartPromotion && v1 instanceof ProductPromotion) {
                return Data_Ordering.GT.value;
            };
            if (v instanceof CartPromotion && v1 instanceof CartPromotion) {
                return Data_Ord.compare(ordCartPromotionRequirement)(v.value0)(v1.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Promotions.Promotion (line 170, column 1 - line 174, column 60): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPromotionConditions;
    }
};
var ordPromotion = {
    compare: function (a) {
        return function (b) {
            return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ord.compare(ordPromotionConditions)(promotionConditions(a))(promotionConditions(b)), Data_Ord.compare(Data_Ord.ordInt)(promotionId(a))(promotionId(b)) ]);
        };
    },
    Eq0: function () {
        return eqPromotion;
    }
};
var encodePromotionType = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Standard";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))
};
var encodePromotionTarget = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericPromotionTarget)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var encodePromotionFilter = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPromotionFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.intEncode)))))(Foreign_Generic_Class.defaultOptions)
};
var encodeProductPromotionRequirements = /* #__PURE__ */ Foreign_Generic_Class.recordEncode()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "repeatable";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
    reflectSymbol: function () {
        return "productFilter";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_PromotionsEngine_ProductFilter.encodeProductSingleFilter))))({
    reflectSymbol: function () {
        return "numRequiredItems";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)));
var encodeFreeProduct = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFreeProduct)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodePromotionPrize = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeFreeProduct)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CouponValue";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))))
};
var encodeCartPromotionRequirement = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCartPromotionRequirement)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Loyalty";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Always";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Never";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))))
};
var encodePromotionConditions = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotionConditions)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCartPromotionRequirement))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeProductPromotionRequirements)))))
};
var encodePromotion = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionType)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionPrize)))({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionConditions)))({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodePromotionFilter)))({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))
};
var defaultPromotionFilter = /* #__PURE__ */ (function () {
    return new PromotionIdFilter([  ]);
})();
var decodePromotionType = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionType)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Standard";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "InformationOnly";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "RequiresCoupon";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))
};
var decodePromotionTarget = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericPromotionTarget)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "CartTarget";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ProductTarget";
        }
    })))
};
var decodePromotionFilter = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPromotionFilter)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PromotionIdFilter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.intDecode))))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.defaultOptions)
};
var decodeProductPromotionRequirements = /* #__PURE__ */ Foreign_Generic_Class.recordDecode()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
    reflectSymbol: function () {
        return "repeatable";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
    reflectSymbol: function () {
        return "productFilter";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_PromotionsEngine_ProductFilter.decodeProductSingleFilter)))())({
    reflectSymbol: function () {
        return "numRequiredItems";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))());
var decodeFreeProduct = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFreeProduct)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FreeProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "productValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "productName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePromotionPrize = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionPrize)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Freeby";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeFreeProduct))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PercentageDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PriceDiscount";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CouponValue";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "TextInformation";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))))
};
var decodeCartPromotionRequirement = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCartPromotionRequirement)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "minCartValue";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FirstOrder";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Loyalty";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "HasCoupon";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Always";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Never";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))))))
};
var decodePromotionConditions = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotionConditions)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CartPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCartPromotionRequirement)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeProductPromotionRequirements)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
var decodePromotion = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Promotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "promotionType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionType))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "prize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionPrize))())({
        reflectSymbol: function () {
            return "conditions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionConditions))())({
        reflectSymbol: function () {
            return "combineTo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodePromotionFilter))())({
        reflectSymbol: function () {
            return "autoAssignable";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var canCombineTo = function (promotion) {
    return function (otherPromotion) {
        return Data_Eq.notEq(eqPromotion)(promotion)(otherPromotion) && inPromotionFilter(otherPromotion)(promotionCombineTo(promotion));
    };
};
var canCombineToAll = function (promotion) {
    return function (promotions) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean))(true)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return canCombineTo(v)(promotion);
        })(promotions));
    };
};
var canCombineWith = function (otherPromotion) {
    return function (promotion) {
        return canCombineTo(promotion)(otherPromotion) && canCombineTo(otherPromotion)(promotion);
    };
};
var canCombineWithAll = function (promotion) {
    return function (promotions) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean))(true)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return canCombineWith(v)(promotion);
        })(promotions));
    };
};
var canCombineWithAllOthers = function (promotion) {
    return function (promotions) {
        var otherPromotions = Data_Array.filter(function (promo) {
            return Data_Eq.notEq(eqPromotion)(promo)(promotion);
        })(promotions);
        return canCombineWithAll(promotion)(otherPromotions);
    };
};
var combineableClique = function (promotions) {
    var cliques = Restaumatic_PromotionsEngine_MaximalCliques.getMaximalCliques(canCombineWith)(promotions);
    return Data_Maybe.fromMaybe([  ])(Data_Array.head(cliques));
};
var allCombineable = function (promotion) {
    return Data_Array.filter(canCombineWith(promotion));
};
export {
    CartValue,
    FirstOrder,
    Loyalty,
    HasCoupon,
    Always,
    Never,
    FreeProduct,
    freeProductName,
    freeProductValue,
    mkFreeProducts,
    Freeby,
    PercentageDiscount,
    PriceDiscount,
    CouponValue,
    TextInformation,
    ProductPromotionRequirements,
    mkProductPromotionRequirements,
    repeatable,
    numRequiredItems,
    CartPromotion,
    ProductPromotion,
    PromotionIdFilter,
    defaultPromotionFilter,
    mkPromotionNoneFilter,
    mkPromotionIdFilter,
    inPromotionFilter,
    Standard,
    InformationOnly,
    RequiresCoupon,
    Promotion,
    mkPromotion,
    mkCartPromotion,
    mkProductPromotion,
    promotionId,
    promotionType,
    promotionPrize,
    promotionConditions,
    promotionCombineTo,
    isAutoAssignablePromotion,
    promotionFreebies,
    isInPromotionFreebies,
    findPromotionFreeby,
    getFirstPromotionFreeby,
    getFirstPromotionFreebyName,
    isCouponPromotion,
    isTextPromotion,
    CartTarget,
    ProductTarget,
    promotionTarget,
    isCartPromotion,
    isProductPromotion,
    isCartPromotionOf,
    isFirstOrderPromotion,
    isLoyaltyPromotion,
    canCombineTo,
    canCombineToAll,
    canCombineWith,
    canCombineWithAll,
    canCombineWithAllOthers,
    allCombineable,
    combineableClique,
    genericCartPromotionRequirement,
    showCartPromotionRequirement,
    eqCartPromotionRequirement,
    encodeCartPromotionRequirement,
    decodeCartPromotionRequirement,
    udecodeCartPromotionRequirement,
    ordCartPromotionRequirement,
    newtypeFreeProduct,
    genericFreeProduct,
    showFreeProduct,
    eqFreeProduct,
    encodeFreeProduct,
    decodeFreeProduct,
    udecodeFreeProduct,
    genericPromotionPrize,
    showPromotionPrize,
    eqPromotionPrize,
    encodePromotionPrize,
    decodePromotionPrize,
    udecodePromotionPrize,
    showProductPromotionRequirements,
    eqProductPromotionRequirements,
    encodeProductPromotionRequirements,
    decodeProductPromotionRequirements,
    udecodeProductPromotionRequirements,
    hasFieldProductPromotionRequirements,
    genericPromotionConditions,
    showPromotionConditions,
    eqPromotionConditions,
    ordPromotionConditions,
    encodePromotionConditions,
    decodePromotionConditions,
    udecodePromotionConditions,
    genericPromotionFilter,
    showPromotionFilter,
    eqPromotionFilter,
    encodePromotionFilter,
    decodePromotionFilter,
    udecodePromotionFilter,
    genericPromotionType,
    showPromotionType,
    eqPromotionType,
    decodePromotionType,
    udecodePromotionType,
    encodePromotionType,
    newtypePromotion,
    genericPromotion,
    eqPromotion,
    encodePromotion,
    decodePromotion,
    udecodePromotion,
    ordPromotion,
    showPromotion,
    genericPromotionTarget,
    showPromotionTarget,
    eqPromotionTarget,
    encodePromotionTarget,
    decodePromotionTarget,
    udecodePromotionTarget
};
//# sourceMappingURL=index.js.map
